module.exports = __webpack_public_path__ + "img/create-wallet-zh-m.a6792bb9.png";